import generator from 'generate-password';
export default {
    defaultParams : {
        length: 12,
        numbers: true,
        symbols: true,
        uppercase: true
    },
    generate: function(params = {}){
        params = Object.assign({}, this.defaultParams, params);
        return generator.generate(params)
    }
}
